import $ from "jquery";
// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
var bar = document.querySelector('.bar')
if($('.top-swiper').length) {
  const topSwiper = new Swiper('.top-swiper', {
    loop: true,
    speed: 1000,
    loopAdditionalSlides: 0,
    preventInteractionOnTransition: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
      // 個別にクラスをつけることができる
      renderBullet: (index, className) => {
        return '<span class="' + className + '"><svg class="circle" width="20" height="20" viewBox="0 0 20 20"><circle class="circle2" cx="10" cy="10" r="7" stroke="rgba(255,255,255,0.4)" stroke-width="3" fill="none"/></circle><circle class="circle1" cx="10" cy="10" r="7" stroke="#fff" stroke-width="3"></circle></svg></span>';
      },
    },
    slidesPerView: 1,
  });

  topSwiper.on('slideChange', function () {// スライド切り替え時発火
    // $('#js-indicator').removeClass('stof0');
    // setTimeout(
    //     function(){$('#js-indicator').addClass('stof0')}
    // , 20);
    // console.log('slide changed');

    if (this.activeIndex > 0) {// 1枚目以降の時
      this.params.autoplay.delay = 4000;// 2枚目以降の表示時間を指定
    }
  });

  $(window).on('load', function() {
    $('.stop-btn').on('click', function() {
      var _class = $(this).attr('class');
      if (_class == 'stop-btn stop') {
        $(this).addClass('start').removeClass('stop');
        $('.swiper-pagination-bullet .circle .circle1').addClass('amt-none');
        topSwiper.autoplay.stop();
      } else {
        $(this).addClass('stop').removeClass('start');
        $('.swiper-pagination-bullet .circle .circle1').removeClass('amt-none');
        topSwiper.autoplay.start();
      }
    });
  });
}

if($('.top-swiper-sp').length) {
  const topSpSwiper = new Swiper('.top-swiper-sp', {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
      // 個別にクラスをつけることができる
      renderBullet: (index, className) => {
        return '<span class="' + className + '"><svg class="circle" width="20" height="20" viewBox="0 0 20 20"><circle class="circle2" cx="10" cy="10" r="7" stroke="rgba(255,255,255,0.4)" stroke-width="3" fill="none"/></circle><circle class="circle1" cx="10" cy="10" r="7" stroke="#fff" stroke-width="3"></circle></svg></span>';
      },
    },
  });   

  topSpSwiper.on('slideChange', function () {// スライド切り替え時発火
    // $('#js-indicator').removeClass('stof0');
    // setTimeout(
    //     function(){$('#js-indicator').addClass('stof0')}
    // , 20);
    // console.log('slide changed');

    if (this.activeIndex > 0) {// 1枚目以降の時
      this.params.autoplay.delay = 4000;// 2枚目以降の表示時間を指定
    }
  });

  $(window).on('load', function() {
    $('.Spstop-btn').on('click', function() {
      var _class = $(this).attr('class');
      if (_class == 'Spstop-btn stop') {
        $(this).addClass('start').removeClass('stop');
        $('.swiper-pagination-bullet .circle .circle1').addClass('amt-none');
        topSpSwiper.autoplay.stop();
      } else {
        $(this).addClass('stop').removeClass('start');
        $('.swiper-pagination-bullet .circle .circle1').removeClass('amt-none');
        topSpSwiper.autoplay.start();
      }
    });
  });

}

/* トップページ メインビジュアル下のバナースライド */
if($('.mvl-bottom-banner-swiper').length) {

  if($('.mvl-bottom-banner-swiper .swiper-slide').length == 2) {
    // 2枚の時
    $('.mvl-bottom-banner-swiper .swiper-wrapper').addClass('tow-slider');
  }else if($('.mvl-bottom-banner-swiper .swiper-slide').length >= 3) {
    // 3枚以上の時
    const mvlBannerSwiper = new Swiper('.mvl-bottom-banner-swiper', {
        slidesPerView: "auto",
        loop: true,
        loopAdditionalSlides: 0,
        spaceBetween: 8,
        slidesPerView: 1,
        centeredSlides: false,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".mvl-bottom-banner-next",
            prevEl: ".mvl-bottom-banner-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                spaceBetween: 16,
                loopAdditionalSlides: 2,
                centeredSlides: true,
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 8,
                loopAdditionalSlides: 2,
                centeredSlides: false,
            },
        },
    });
  }
  // 2枚以下の時
  if($('.mvl-bottom-banner-swiper .swiper-slide').length <= 2) {
    $('.mvl-bottom-banner-next, .mvl-bottom-banner-prev').hide();
  }
  // 1枚の時
  if($('.mvl-bottom-banner-swiper .swiper-slide').length == 1) {
    $('.mvl-bottom-banner-swiper .swiper-wrapper').addClass('one-slider');
  }
}

if($('.js-shop-swiper').length) {
  const shopSwiper = new Swiper('.js-shop-swiper', {
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30
      },
    }
  });
}
if($('.voice-swiper').length) {
  const voiceSwiper = new Swiper('.voice-swiper', {
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    loop: true,
    freeMode: true,
    speed: 8500,
    loopedSlides: 6,
    slidesPerView:  3,
    spaceBetween: 5,
    direction: 'horizontal',
    loopPreventsSlide: false,
    freeModeMomentum: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    on: {
      touchEnd: () => {
          let getTranslate = voiceSwiper.getTranslate(); // スライドの現在位置を取得
          let slideWidth = document.querySelector('.swiper-slide-active').offsetWidth; //スライドの横幅を取得
          voiceSwiper.setTranslate(getTranslate - slideWidth); // translateを更新
          voiceSwiper.setTransition(14000); //transitonを更新
      },
    },

    breakpoints: {
      576: {
        slidesPerView:  2.2,
        spaceBetween: 20,
        centeredSlides: true,
        initialSlide: 1,
      },
      992: {
        slidesPerView:  5,
        spaceBetween: 20,
        centeredSlides: true,
        initialSlide: 1,
      },
      1201: {
        slidesPerView:  8,
        spaceBetween: 20,
        centeredSlides: true,
        initialSlide: 1,
      },
    }
  });
}